import { render } from "./FilterBuilding.vue?vue&type=template&id=70b26581&bindings={\"settings\":\"options\",\"selectedOption\":\"options\",\"display\":\"options\"}"
import script from "./FilterBuilding.vue?vue&type=script&lang=js"
export * from "./FilterBuilding.vue?vue&type=script&lang=js"
script.render = render

export default script